<script setup lang="ts">
import AppHeader from '@/components/layout/AppHeader.vue';
import ResendRecoveryDialog from '@/components/common/ResendRecoveryDialog.vue';
import LocalImportDialog from '@/components/common/LocalImportDialog.vue';
import ReloadBanner from '@/components/common/ReloadBanner.vue';
</script>

<template>
  <v-app>
    <ReloadBanner />
    <AppHeader />
    <v-main>
      <router-view />
    </v-main>
    <ResendRecoveryDialog />
    <LocalImportDialog />
  </v-app>
</template>

<style>
.v-application {
  background-color: var(--ds-bg-primary) !important;
}
</style>
